const MAIL_STATUSES = {
  DRAFT: 'draft',
  SENDING: 'sending',
  SENDING_FAILED: 'sending_failed',
  SEND_REQUEST: 'send_request',
  PENDING: 'pending',
  SENT: 'sent',
  READY: 'ready',
  PARTIALLY_SENDING_FAILED: 'partially_sending_failed',
} as const;

export default MAIL_STATUSES;
